module.exports = __webpack_public_path__ + "img/carrusel_2.3aae2051.png";